var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Transition',{attrs:{"name":"pop"}},[_c('router-view')],1),_c('RightDrawer',{attrs:{"is-visible":_vm.visible}},[_c('router-view',{key:_vm.$route.path,attrs:{"name":"sidesheet"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }